
// // src/pages/EmployeeDashboard.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { useAuthUser, useUserDoc, deriveCategoryKey } from "../lib/useAuthUser";
// import { subscribeEmployeeByUid } from "../lib/employeesApi";
// import { subscribeServiceItems } from "../lib/servicesApi";
// import { subscribeBookingsByCategory } from "../lib/bookingsApi";

// const TABS = [
//     { key: "profile", label: "My Profile", icon: "bi-person" },
//     { key: "services", label: "My Services", icon: "bi-briefcase" },
//     { key: "bookings", label: "Category Bookings", icon: "bi-calendar-check" },
// ];

// const EmployeeDashboard = () => {
//     const { user, status: authStatus } = useAuthUser(); // 'loading' | 'signed-in' | 'signed-out'
//     const { userDoc } = useUserDoc(user?.uid);

//     // Active tab state
//     const [activeTab, setActiveTab] = useState("profile");

//     // Employee profile
//     const [emp, setEmp] = useState(null);
//     const [empLoading, setEmpLoading] = useState(true);
//     const [empErr, setEmpErr] = useState(null);

//     // Subscribe employee doc after we know the auth user
//     useEffect(() => {
//         if (authStatus !== "signed-in" || !user?.uid) {
//             setEmp(null);
//             setEmpLoading(false);
//             return;
//         }
//         setEmpLoading(true);
//         const unsub = subscribeEmployeeByUid(
//             user.uid,
//             (doc) => {
//                 setEmp(doc);
//                 setEmpLoading(false);
//             },
//             (err) => {
//                 setEmpErr(err);
//                 setEmpLoading(false);
//             }
//         );
//         return () => unsub && unsub();
//     }, [authStatus, user?.uid]);

//     // Resolve main category for employee flows
//     const categoryKey = useMemo(
//         () => deriveCategoryKey({ userDoc, employeeDoc: emp }),
//         [userDoc, emp]
//     );

//     // Services in my category
//     const [services, setServices] = useState([]);
//     const [svcLoading, setSvcLoading] = useState(true);
//     const [svcErr, setSvcErr] = useState(null);

//     useEffect(() => {
//         if (activeTab !== "services") return; // fetch only when needed
//         if (!categoryKey) {
//             setServices([]);
//             setSvcLoading(false);
//             return;
//         }
//         setSvcLoading(true);
//         const unsub = subscribeServiceItems(
//             (items) => {
//                 setServices((items || []).filter((s) => !!s.isActive));
//                 setSvcLoading(false);
//             },
//             (err) => {
//                 setSvcErr(err);
//                 setSvcLoading(false);
//             },
//             { category: categoryKey }
//         );
//         return () => unsub && unsub();
//     }, [activeTab, categoryKey]);

//     // Bookings in my category
//     const [bookings, setBookings] = useState([]);
//     const [bkLoading, setBkLoading] = useState(true);
//     const [bkErr, setBkErr] = useState(null);
//     const [search, setSearch] = useState("");

//     useEffect(() => {
//         if (activeTab !== "bookings") return; // fetch only when needed
//         if (!categoryKey) {
//             setBookings([]);
//             setBkLoading(false);
//             return;
//         }
//         setBkLoading(true);
//         const unsub = subscribeBookingsByCategory(
//             categoryKey,
//             (items) => {
//                 setBookings(items || []);
//                 setBkLoading(false);
//             },
//             (err) => {
//                 setBkErr(err);
//                 setBkLoading(false);
//             }
//         );
//         return () => unsub && unsub();
//     }, [activeTab, categoryKey]);

//     // Search (bookings)
//     const norm = (v) => String(v ?? "").toLowerCase();
//     const filteredBookings = useMemo(() => {
//         const t = norm(search);
//         if (!t) return bookings;
//         return bookings.filter((b) => {
//             const id = norm(b.id);
//             const sName = norm(b.serviceName);
//             const addr = norm(b.address);
//             const fd = b.formData || {};
//             const phone = norm(fd.phone || fd.mobile || fd.contactPhone || "");
//             const customer = norm(fd.name || fd.fullName || fd.customerName || "");
//             return (
//                 id.includes(t) ||
//                 sName.includes(t) ||
//                 addr.includes(t) ||
//                 phone.includes(t) ||
//                 customer.includes(t)
//             );
//         });
//     }, [bookings, search]);

//     // Header string
//     const topRight =
//         authStatus === "loading"
//             ? "Checking sign-in…"
//             : authStatus === "signed-out"
//                 ? "Signed out"
//                 : `Signed in as: ${user?.email || user?.uid}`;

//     return (
//         <section className="py-4">
//             <div className="container">
//                 {/* Header */}
//                 <header className="d-flex justify-content-between align-items-center mb-3">
//                     <h2 className="fw-bold">Employee Dashboard</h2>
//                     <span className="text-muted small">{topRight}</span>
//                 </header>

//                 {/* Mobile tab bar (sticky) */}
//                 <div
//                     className="d-md-none mb-3"
//                     style={{ position: "sticky", top: 0, zIndex: 30 }}
//                 >
//                     <div className="bg-light border rounded-3 p-2 d-flex gap-2 overflow-auto">
//                         {TABS.map((t) => (
//                             <button
//                                 key={t.key}
//                                 type="button"
//                                 className={`btn btn-sm ${activeTab === t.key ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center gap-2`}
//                                 onClick={() => setActiveTab(t.key)}
//                             >
//                                 <i className={`bi ${t.icon}`} />
//                                 <span className="text-nowrap">{t.label}</span>
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="row g-3">
//                     {/* Left sidebar tabs (hidden on mobile) */}
//                     <aside className="col-md-3 d-none d-md-block">
//                         <div className="card shadow-sm">
//                             <div className="card-header">Navigation</div>
//                             <ul className="list-group list-group-flush">
//                                 {TABS.map((t) => (
//                                     <li key={t.key} className="list-group-item p-0">
//                                         <button
//                                             type="button"
//                                             className={`w-100 text-start btn ${activeTab === t.key ? "btn-primary" : "btn-light"} d-flex align-items-center gap-2 p-2`}
//                                             onClick={() => setActiveTab(t.key)}
//                                         >
//                                             <i className={`bi ${t.icon}`} />
//                                             <span>{t.label}</span>
//                                             {/* Optional counters */}
//                                             {t.key === "services" && (
//                                                 <span className="badge bg-secondary ms-auto">{services.length}</span>
//                                             )}
//                                             {t.key === "bookings" && (
//                                                 <span className="badge bg-secondary ms-auto">{bookings.length}</span>
//                                             )}
//                                         </button>
//                                     </li>
//                                 ))}
//                             </ul>
//                         </div>
//                     </aside>

//                     {/* Right content area */}
//                     <main className="col-12 col-md-9">
//                         {/* PROFILE TAB */}
//                         {activeTab === "profile" && (
//                             <div className="card shadow-sm mb-3">
//                                 <div className="card-header">My Profile</div>
//                                 <div className="card-body">
//                                     {authStatus === "loading" ? (
//                                         <div className="text-muted">Checking sign-in…</div>
//                                     ) : authStatus === "signed-out" ? (
//                                         <div className="alert alert-danger">Not signed in</div>
//                                     ) : empLoading ? (
//                                         <div className="text-muted">Loading profile…</div>
//                                     ) : empErr ? (
//                                         <div className="alert alert-danger">{empErr.message}</div>
//                                     ) : !emp ? (
//                                         <div className="alert alert-warning">
//                                             No employee profile found for this account (uid: {user?.uid}). Ask an admin to link your profile.
//                                         </div>
//                                     ) : (
//                                         <>
//                                             <div className="row g-3">
//                                                 <div className="col-lg-4">
//                                                     <div><strong>Name:</strong> {(emp.firstName || "") + " " + (emp.lastName || "")}</div>
//                                                     <div><strong>Mobile:</strong> {emp.mobile || "-"}</div>
//                                                     <div><strong>Aadhaar:</strong> {emp.aadhaar || "-"}</div>
//                                                 </div>
//                                                 <div className="col-lg-4">
//                                                     <div><strong>Category:</strong> {emp.categoryKey || emp.jobs?.[0]?.categoryKey || "-"}</div>
//                                                     <div><strong>Subcategory:</strong> {emp.subcategoryKey || emp.jobs?.[0]?.subcategoryKey || "-"}</div>
//                                                     <div><strong>Status:</strong> <span className="badge bg-secondary">{emp.status || "-"}</span></div>
//                                                 </div>
//                                                 <div className="col-lg-4">
//                                                     <div><strong>Address:</strong> {emp.address || "-"}</div>
//                                                     <div><strong>Total Exp (yrs):</strong> {emp.experienceYears ?? "-"}</div>
//                                                     <div><strong>Age:</strong> {emp.ageYears ?? "-"}</div>
//                                                 </div>
//                                             </div>

//                                             {Array.isArray(emp.jobs) && emp.jobs.length > 0 && (
//                                                 <>
//                                                     <hr />
//                                                     <div className="mb-2"><strong>Jobs</strong></div>
//                                                     <div className="table-responsive">
//                                                         <table className="table table-sm">
//                                                             <thead>
//                                                                 <tr>
//                                                                     <th>Title</th>
//                                                                     <th>Category</th>
//                                                                     <th>Subcategory</th>
//                                                                     <th>Exp (yrs)</th>
//                                                                 </tr>
//                                                             </thead>
//                                                             <tbody>
//                                                                 {emp.jobs.map((j, idx) => (
//                                                                     <tr key={idx}>
//                                                                         <td>{j.title || "-"}</td>
//                                                                         <td>{j.categoryKey || "-"}</td>
//                                                                         <td>{j.subcategoryKey || "-"}</td>
//                                                                         <td>{j.experienceYears ?? "-"}</td>
//                                                                     </tr>
//                                                                 ))}
//                                                             </tbody>
//                                                         </table>
//                                                     </div>
//                                                 </>
//                                             )}
//                                         </>
//                                     )}
//                                 </div>
//                             </div>
//                         )}

//                         {/* SERVICES TAB */}
//                         {activeTab === "services" && (
//                             <div className="card shadow-sm mb-3">
//                                 <div className="card-header">Services in My Category</div>
//                                 <div className="card-body">
//                                     {!categoryKey && authStatus === "signed-in" ? (
//                                         <div className="alert alert-warning">
//                                             No category found for your profile. Ask admin to set your <code>serviceCategory</code> or employee <code>categoryKey</code>.
//                                         </div>
//                                     ) : svcLoading ? (
//                                         <div className="text-muted">Loading services…</div>
//                                     ) : svcErr ? (
//                                         <div className="alert alert-danger">{svcErr.message}</div>
//                                     ) : services.length === 0 ? (
//                                         <div className="alert alert-info mb-0">No active services found in your category.</div>
//                                     ) : (
//                                         <div className="row g-3">
//                                             {services.map((s) => {
//                                                 const title = s.name || s.title || "Untitled";
//                                                 const desc = s.description || s.desc || "";
//                                                 const icon = s.icon || "bi-tools";
//                                                 const price = typeof s.price === "number" ? s.price : Number(s.price) || 0;
//                                                 return (
//                                                     <div key={s.id} className="col-12 col-sm-6 col-lg-4">
//                                                         <article className="card h-100 shadow-sm">
//                                                             <div className="card-body d-flex flex-column">
//                                                                 <div className="d-flex align-items-center mb-2">
//                                                                     <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
//                                                                         <i className={`bi ${icon} text-primary fs-5`} />
//                                                                     </span>
//                                                                     <h6 className="mb-0">{title}</h6>
//                                                                 </div>
//                                                                 <p className="text-muted flex-grow-1">{desc}</p>
//                                                                 <div className="text-secondary small">Starting at ₹{price}</div>
//                                                             </div>
//                                                         </article>
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         )}

//                         {/* BOOKINGS TAB */}
//                         {activeTab === "bookings" && (
//                             <div className="card shadow-sm">
//                                 <div className="card-header d-flex align-items-center justify-content-between">
//                                     <span>Bookings for My Category</span>
//                                     <input
//                                         className="form-control form-control-sm"
//                                         style={{ maxWidth: 320 }}
//                                         placeholder="Search id/name/phone/address…"
//                                         value={search}
//                                         onChange={(e) => setSearch(e.target.value)}
//                                     />
//                                 </div>
//                                 <div className="card-body">
//                                     {!categoryKey && authStatus === "signed-in" ? (
//                                         <div className="alert alert-warning">
//                                             No category found for your profile. Ask admin to set your <code>serviceCategory</code> or employee <code>categoryKey</code>.
//                                         </div>
//                                     ) : bkLoading ? (
//                                         <div className="text-muted">Loading bookings…</div>
//                                     ) : bkErr ? (
//                                         <div className="alert alert-danger">{bkErr.message}</div>
//                                     ) : filteredBookings.length === 0 ? (
//                                         <div className="alert alert-info mb-0">No bookings found.</div>
//                                     ) : (
//                                         <div className="table-responsive">
//                                             <table className="table table-sm table-striped align-middle">
//                                                 <thead className="table-light">
//                                                     <tr>
//                                                         <th>Booking ID</th>
//                                                         <th>Service</th>
//                                                         <th>Requested At</th>
//                                                         <th>Customer</th>
//                                                         <th>Phone</th>
//                                                         <th>Address</th>
//                                                         <th>Status</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {filteredBookings.map((b) => {
//                                                         const dt = b.requestedAt?.seconds
//                                                             ? new Date(b.requestedAt.seconds * 1000).toLocaleString()
//                                                             : "-";
//                                                         const fd = b.formData || {};
//                                                         const customer = fd.name || fd.fullName || fd.customerName || "-";
//                                                         const phone = fd.phone || fd.mobile || fd.contactPhone || "-";
//                                                         return (
//                                                             <tr key={b.id}>
//                                                                 <td className="text-monospace">{b.id}</td>
//                                                                 <td>{b.serviceName}</td>
//                                                                 <td>{dt}</td>
//                                                                 <td>{customer}</td>
//                                                                 <td>{phone}</td>
//                                                                 <td style={{ maxWidth: 280 }} className="text-truncate" title={b.address || ""}>
//                                                                     {b.address || "-"}
//                                                                 </td>
//                                                                 <td><span className="badge bg-secondary">{b.status}</span></td>
//                                                             </tr>
//                                                         );
//                                                     })}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>
//                         )}
//                     </main>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default EmployeeDashboard;


// src/pages/EmployeeDashboard.jsx
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useAuthUser, useUserDoc, deriveCategoryKey } from "../lib/useAuthUser";
import { subscribeEmployeeByUid } from "../lib/employeesApi";
import { subscribeServiceItems } from "../lib/servicesApi";
import {
    subscribeOpenJobsByCategory,
    subscribeMyActiveJob,
    claimJobTransaction,
    completeJobTransaction,
} from "../lib/bookingsApi";
import { useBeep, showNotification } from "../lib/useAlarm";

const TABS = [
    { key: "profile", label: "My Profile", icon: "bi-person" },
    { key: "services", label: "My Services", icon: "bi-briefcase" },
    { key: "bookings", label: "Category Bookings", icon: "bi-calendar-check" },
    { key: "jobs", label: "Jobs", icon: "bi-wrench-adjustable-circle" }, // NEW
];

const EmployeeDashboard = () => {
    const { user, status: authStatus } = useAuthUser();  // 'loading' | 'signed-in' | 'signed-out'
    const { userDoc } = useUserDoc(user?.uid);
    const beep = useBeep();

    const [activeTab, setActiveTab] = useState("profile");

    /** Employee profile */
    const [emp, setEmp] = useState(null);
    const [empLoading, setEmpLoading] = useState(true);
    const [empErr, setEmpErr] = useState(null);

    useEffect(() => {
        if (authStatus !== "signed-in" || !user?.uid) {
            setEmp(null); setEmpLoading(false);
            return;
        }
        setEmpLoading(true);
        const unsub = subscribeEmployeeByUid(
            user.uid,
            (doc) => { setEmp(doc); setEmpLoading(false); },
            (err) => { setEmpErr(err); setEmpLoading(false); }
        );
        return () => unsub && unsub();
    }, [authStatus, user?.uid]);

    /** Category resolution */
    const categoryKey = useMemo(
        () => deriveCategoryKey({ userDoc, employeeDoc: emp }),
        [userDoc, emp]
    );

    /** Location selector (optional; default 'all') */
    const [locationKey, setLocationKey] = useState("all");
    // You can populate `locationKey` from emp.address / userDoc.serviceCategoryLocation etc.

    /** SERVICES TAB */
    const [services, setServices] = useState([]);
    const [svcLoading, setSvcLoading] = useState(true);
    const [svcErr, setSvcErr] = useState(null);

    useEffect(() => {
        if (activeTab !== "services") return;
        if (!categoryKey) { setServices([]); setSvcLoading(false); return; }
        setSvcLoading(true);
        const unsub = subscribeServiceItems(
            (items) => { setServices((items || []).filter((s) => !!s.isActive)); setSvcLoading(false); },
            (err) => { setSvcErr(err); setSvcLoading(false); },
            { category: categoryKey }
        );
        return () => unsub && unsub();
    }, [activeTab, categoryKey]);

    /** BOOKINGS TAB */
    const [bookings, setBookings] = useState([]);
    const [bkLoading, setBkLoading] = useState(true);
    const [bkErr, setBkErr] = useState(null);
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (activeTab !== "bookings") return;
        if (!categoryKey) { setBookings([]); setBkLoading(false); return; }
        setBkLoading(true);
        // Reuse open jobs subscription for category, but we want *all* bookings in category for viewing.
        // For simplicity, use subscribeOpenJobsByCategory here; or build a dedicated subscribeBookingsByCategory if needed.
        const unsub = subscribeOpenJobsByCategory(
            { categoryKey, locationKey: "all" },
            (items) => { setBookings(items || []); setBkLoading(false); },
            (err) => { setBkErr(err); setBkLoading(false); }
        );
        return () => unsub && unsub();
    }, [activeTab, categoryKey]);

    /** JOBS TAB */
    const [jobs, setJobs] = useState([]);         // open jobs in my category & location
    const [jobsLoading, setJobsLoading] = useState(true);
    const [jobsErr, setJobsErr] = useState(null);
    const [myActiveJob, setMyActiveJob] = useState(null);
    const prevJobsCountRef = useRef(0);           // for alarm
    const [claimingId, setClaimingId] = useState(null);
    const [completingId, setCompletingId] = useState(null);

    // Subscribe OPEN jobs in my category + location
    useEffect(() => {
        if (activeTab !== "jobs") return;
        if (!categoryKey) { setJobs([]); setJobsLoading(false); return; }
        setJobsLoading(true);
        const unsub = subscribeOpenJobsByCategory(
            { categoryKey, locationKey },
            (items) => {
                // Alarm: play beep if count increases
                if (items.length > prevJobsCountRef.current) {
                    beep(880, 160);
                    showNotification("New job available", `A new ${categoryKey} request arrived.`);
                }
                prevJobsCountRef.current = items.length;
                setJobs(items || []);
                setJobsLoading(false);
            },
            (err) => { setJobsErr(err); setJobsLoading(false); }
        );
        return () => unsub && unsub();
    }, [activeTab, categoryKey, locationKey]);

    // Subscribe my active job (claimed/in-progress, not completed)
    useEffect(() => {
        if (activeTab !== "jobs") return;
        if (authStatus !== "signed-in" || !user?.uid) { setMyActiveJob(null); return; }
        const unsub = subscribeMyActiveJob(
            user.uid,
            (doc) => setMyActiveJob(doc),
            console.error
        );
        return () => unsub && unsub();
    }, [activeTab, authStatus, user?.uid]);

    const handleClaim = async (job) => {
        if (!user?.uid) return alert("Not signed in");
        if (myActiveJob) return alert("You already have an active job. Complete it before claiming another.");
        try {
            setClaimingId(job.id);
            await claimJobTransaction(job.id, user.uid, { blockIfActiveJob: true });
            beep(660, 140);
            showNotification("Job claimed", `You claimed job ${job.id}`);
        } catch (e) {
            alert(e?.message || "Failed to claim job");
        } finally {
            setClaimingId(null);
        }
    };

    const handleComplete = async () => {
        if (!user?.uid) return alert("Not signed in");
        if (!myActiveJob) return alert("No active job to complete.");
        try {
            setCompletingId(myActiveJob.id);
            await completeJobTransaction(myActiveJob.id, user.uid);
            beep(520, 140);
            showNotification("Job completed", `Job ${myActiveJob.id} marked completed`);
        } catch (e) {
            alert(e?.message || "Failed to complete job");
        } finally {
            setCompletingId(null);
        }
    };

    // Search filter (bookings tab)
    const norm = (v) => String(v ?? "").toLowerCase();
    const filteredBookings = useMemo(() => {
        const t = norm(search);
        if (!t) return bookings;
        return bookings.filter((b) => {
            const id = norm(b.id);
            const sName = norm(b.serviceName);
            const addr = norm(b.address);
            const fd = b.formData || {};
            const phone = norm(fd.phone || fd.mobile || fd.contactPhone || "");
            const customer = norm(fd.name || fd.fullName || fd.customerName || "");
            return (
                id.includes(t) ||
                sName.includes(t) ||
                addr.includes(t) ||
                phone.includes(t) ||
                customer.includes(t)
            );
        });
    }, [bookings, search]);

    const topRight =
        authStatus === "loading"
            ? "Checking sign-in…"
            : authStatus === "signed-out"
                ? "Signed out"
                : `Signed in as: ${user?.email || user?.uid}`;

    // Show Jobs badge count in tabs
    const jobsCountBadge = jobs.length;

    return (
        <section className="py-4">
            <div className="container">
                <header className="d-flex justify-content-between align-items-center mb-3">
                    <h2 className="fw-bold">Employee Dashboard</h2>
                    <span className="text-muted small">{topRight}</span>
                </header>

                {/* Mobile tabs */}
                <div className="d-md-none mb-3" style={{ position: "sticky", top: 0, zIndex: 30 }}>
                    <div className="bg-light border rounded-3 p-2 d-flex gap-2 overflow-auto">
                        {TABS.map((t) => (
                            <button
                                key={t.key}
                                type="button"
                                className={`btn btn-sm ${activeTab === t.key ? "btn-primary" : "btn-outline-primary"} d-flex align-items-center gap-2`}
                                onClick={() => setActiveTab(t.key)}
                            >
                                <i className={`bi ${t.icon}`} />
                                <span className="text-nowrap">{t.label}</span>
                                {t.key === "jobs" && (
                                    <span className="badge bg-danger ms-1">{jobsCountBadge}</span>
                                )}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="row g-3">
                    {/* Sidebar (desktop) */}
                    <aside className="col-md-3 d-none d-md-block">
                        <div className="card shadow-sm">
                            {/* <div className="card-header">Navigation</div> */}
                            <ul className="list-group list-group-flush">
                                {TABS.map((t) => (
                                    <li key={t.key} className="list-group-item p-0">
                                        <button
                                            type="button"
                                            className={`w-100 text-start btn ${activeTab === t.key ? "btn-primary" : "btn-light"} d-flex align-items-center gap-2 p-2`}
                                            onClick={() => setActiveTab(t.key)}
                                        >
                                            <i className={`bi ${t.icon}`} />
                                            <span>{t.label}</span>
                                            {t.key === "jobs" && (
                                                <span className="badge bg-secondary ms-auto">{jobsCountBadge}</span>
                                            )}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </aside>

                    {/* Content area */}
                    <main className="col-12 col-md-9">
                        {/* PROFILE */}
                        {activeTab === "profile" && (
                            <div className="card shadow-sm mb-3">
                                <div className="card-header">My Profile</div>
                                <div className="card-body">
                                    {authStatus === "loading" ? (
                                        <div className="text-muted">Checking sign-in…</div>
                                    ) : authStatus === "signed-out" ? (
                                        <div className="alert alert-danger">Not signed in</div>
                                    ) : empLoading ? (
                                        <div className="text-muted">Loading profile…</div>
                                    ) : empErr ? (
                                        <div className="alert alert-danger">{empErr.message}</div>
                                    ) : !emp ? (
                                        <div className="alert alert-warning">
                                            No employee profile found for this account (uid: {user?.uid}). Ask admin to link your profile.
                                        </div>
                                    ) : (
                                        <>
                                            <div className="row g-3">
                                                <div className="col-lg-4">
                                                    <div><strong>Name:</strong> {(emp.firstName || "") + " " + (emp.lastName || "")}</div>
                                                    <div><strong>Mobile:</strong> {emp.mobile || "-"}</div>
                                                    <div><strong>Aadhaar:</strong> {emp.aadhaar || "-"}</div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div><strong>Category:</strong> {emp.categoryKey || emp.jobs?.[0]?.categoryKey || "-"}</div>
                                                    <div><strong>Subcategory:</strong> {emp.subcategoryKey || emp.jobs?.[0]?.subcategoryKey || "-"}</div>
                                                    <div><strong>Status:</strong> <span className="badge bg-secondary">{emp.status || "-"}</span></div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div><strong>Address:</strong> {emp.address || "-"}</div>
                                                    <div><strong>Total Exp (yrs):</strong> {emp.experienceYears ?? "-"}</div>
                                                    <div><strong>Age:</strong> {emp.ageYears ?? "-"}</div>
                                                </div>
                                            </div>
                                            {Array.isArray(emp.jobs) && emp.jobs.length > 0 && (
                                                <>
                                                    <hr />
                                                    <div className="mb-2"><strong>Jobs</strong></div>
                                                    <div className="table-responsive">
                                                        <table className="table table-sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Title</th>
                                                                    <th>Category</th>
                                                                    <th>Subcategory</th>
                                                                    <th>Exp (yrs)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emp.jobs.map((j, idx) => (
                                                                    <tr key={idx}>
                                                                        <td>{j.title || "-"}</td>
                                                                        <td>{j.categoryKey || "-"}</td>
                                                                        <td>{j.subcategoryKey || "-"}</td>
                                                                        <td>{j.experienceYears ?? "-"}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* SERVICES */}
                        {activeTab === "services" && (
                            <div className="card shadow-sm mb-3">
                                <div className="card-header">Services in My Category</div>
                                <div className="card-body">
                                    {!categoryKey && authStatus === "signed-in" ? (
                                        <div className="alert alert-warning">
                                            No category found for your profile. Ask admin to set your <code>serviceCategory</code> or employee <code>categoryKey</code>.
                                        </div>
                                    ) : svcLoading ? (
                                        <div className="text-muted">Loading services…</div>
                                    ) : svcErr ? (
                                        <div className="alert alert-danger">{svcErr.message}</div>
                                    ) : services.length === 0 ? (
                                        <div className="alert alert-info mb-0">No active services found in your category.</div>
                                    ) : (
                                        <div className="row g-3">
                                            {services.map((s) => {
                                                const title = s.name || s.title || "Untitled";
                                                const desc = s.description || s.desc || "";
                                                const icon = s.icon || "bi-tools";
                                                const price = typeof s.price === "number" ? s.price : Number(s.price) || 0;
                                                return (
                                                    <div key={s.id} className="col-12 col-sm-6 col-lg-4">
                                                        <article className="card h-100 shadow-sm">
                                                            <div className="card-body d-flex flex-column">
                                                                <div className="d-flex align-items-center mb-2">
                                                                    <span className="rounded-3 p-2 me-2" style={{ background: "#EEF2FF" }}>
                                                                        <i className={`bi ${icon} text-primary fs-5`} />
                                                                    </span>
                                                                    <h6 className="mb-0">{title}</h6>
                                                                </div>
                                                                <p className="text-muted flex-grow-1">{desc}</p>
                                                                <div className="text-secondary small">Starting at ₹{price}</div>
                                                            </div>
                                                        </article>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* BOOKINGS */}
                        {activeTab === "bookings" && (
                            <div className="card shadow-sm mb-3">
                                <div className="card-header d-flex align-items-center justify-content-between">
                                    <span>Bookings for My Category</span>
                                    <input
                                        className="form-control form-control-sm"
                                        style={{ maxWidth: 320 }}
                                        placeholder="Search id/name/phone/address…"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </div>
                                <div className="card-body">
                                    {!categoryKey && authStatus === "signed-in" ? (
                                        <div className="alert alert-warning">
                                            No category found for your profile. Ask admin to set your <code>serviceCategory</code> or employee <code>categoryKey</code>.
                                        </div>
                                    ) : bkLoading ? (
                                        <div className="text-muted">Loading bookings…</div>
                                    ) : bkErr ? (
                                        <div className="alert alert-danger">{bkErr.message}</div>
                                    ) : filteredBookings.length === 0 ? (
                                        <div className="alert alert-info mb-0">No bookings found.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-sm table-striped align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Booking ID</th>
                                                        <th>Service</th>
                                                        <th>Requested At</th>
                                                        <th>Customer</th>
                                                        <th>Phone</th>
                                                        <th>Address</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredBookings.map((b) => {
                                                        const dt = b.requestedAt?.seconds
                                                            ? new Date(b.requestedAt.seconds * 1000).toLocaleString()
                                                            : "-";
                                                        const fd = b.formData || {};
                                                        const customer = fd.name || fd.fullName || fd.customerName || "-";
                                                        const phone = fd.phone || fd.mobile || fd.contactPhone || "-";
                                                        return (
                                                            <tr key={b.id}>
                                                                <td className="text-monospace">{b.id}</td>
                                                                <td>{b.serviceName}</td>
                                                                <td>{dt}</td>
                                                                <td>{customer}</td>
                                                                <td>{phone}</td>
                                                                <td style={{ maxWidth: 280 }} className="text-truncate" title={b.address || ""}>
                                                                    {b.address || "-"}
                                                                </td>
                                                                <td><span className="badge bg-secondary">{b.status}</span></td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* JOBS (NEW) */}
                        {activeTab === "jobs" && (
                            <div className="card shadow-sm">
                                <div className="card-header d-flex align-items-center justify-content-between">
                                    <span>Jobs</span>
                                    <div className="d-flex align-items-center gap-2">
                                        <label className="form-label mb-0">Location</label>
                                        <select
                                            className="form-select form-select-sm"
                                            value={locationKey}
                                            onChange={(e) => setLocationKey(e.target.value)}
                                            style={{ minWidth: 180 }}
                                        >
                                            {/* TODO: populate from employee profile or communities */}
                                            <option value="all">All</option>
                                            <option value="pincode-560001">Pincode 560001</option>
                                            <option value="pincode-560002">Pincode 560002</option>
                                            {/* Add more meaningful keys from your data */}
                                        </select>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {/* My active job (if any) */}
                                    {myActiveJob && (
                                        <div className="alert alert-warning d-flex align-items-center justify-content-between">
                                            <div>
                                                <strong>Active Job:</strong> {myActiveJob.serviceName} &nbsp;
                                                <span className="text-monospace">({myActiveJob.id})</span>
                                            </div>
                                            <button
                                                className="btn btn-sm btn-success"
                                                onClick={handleComplete}
                                                disabled={!!completingId}
                                            >
                                                {completingId ? "Completing..." : "Mark Completed"}
                                            </button>
                                        </div>
                                    )}

                                    {/* Open jobs list */}
                                    {!categoryKey && authStatus === "signed-in" ? (
                                        <div className="alert alert-warning">
                                            No category found for your profile. Ask admin to set your <code>serviceCategory</code> or employee <code>categoryKey</code>.
                                        </div>
                                    ) : jobsLoading ? (
                                        <div className="text-muted">Loading jobs…</div>
                                    ) : jobsErr ? (
                                        <div className="alert alert-danger">{jobsErr.message}</div>
                                    ) : jobs.length === 0 ? (
                                        <div className="alert alert-info mb-0">No open jobs in your category & location.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-sm table-striped align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Job ID</th>
                                                        <th>Service</th>
                                                        <th>Requested At</th>
                                                        <th>Customer</th>
                                                        <th>Phone</th>
                                                        <th>Address</th>
                                                        <th style={{ width: 160 }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {jobs.map((b) => {
                                                        const dt = b.requestedAt?.seconds
                                                            ? new Date(b.requestedAt.seconds * 1000).toLocaleString()
                                                            : "-";
                                                        const fd = b.formData || {};
                                                        const customer = fd.name || fd.fullName || fd.customerName || "-";
                                                        const phone = fd.phone || fd.mobile || fd.contactPhone || "-";
                                                        return (
                                                            <tr key={b.id}>
                                                                <td className="text-monospace">{b.id}</td>
                                                                <td>{b.serviceName}</td>
                                                                <td>{dt}</td>
                                                                <td>{customer}</td>
                                                                <td>{phone}</td>
                                                                <td style={{ maxWidth: 280 }} className="text-truncate" title={b.address || ""}>
                                                                    {b.address || "-"}
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() => handleClaim(b)}
                                                                        disabled={!!myActiveJob || claimingId === b.id}
                                                                        title={myActiveJob ? "You have an active job" : "Claim this job"}
                                                                    >
                                                                        {claimingId === b.id ? "Claiming…" : "Claim"}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </main>
                </div>
            </div>
        </section>
    );
};

export default EmployeeDashboard;
